<!-- 登陆页面 -->
<template>
    <div class="login-wrap">
        <div class="login-cont">
            <div class="cont-header">
                <i class="header-ico el-icon-arrow-left"></i>
            </div>
            <div class="cont-main">
                <!--密码，验证码切换 头部-->
                <div class="switch-bar">
                    <p :class="[{ selected: loginWay === 1 },'sep-line']" @click="changeWay(1)">
                        账号登录
                    </p>
                    <p :class="{ selected: loginWay === 2 }" @click="changeWay(2)">
                        验证码登录
                    </p>
                </div>
                <!-- 表单 -->
                <div class="form-box">
                    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form">
                        <el-form-item prop="userName" v-if="loginWay === 1">
                            <label class="label-txt" for="">账号</label>
                            <el-input v-model="loginForm.userName" placeholder="请输入账号" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="pwd" v-if="loginWay === 1">
                            <label class="label-txt" for="">密码</label>
                            <el-input type="password" placeholder="请输入密码" v-model="loginForm.pwd" clearable
                                show-password>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="tel" v-if="loginWay === 2">
                            <label class="label-txt" for="">手机号</label>
                            <el-input v-model="loginForm.tel" placeholder="请输入手机号" maxlength="11" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="code" v-if="loginWay === 2">
                            <label class="label-txt" for="">验证码</label>
                            <el-input type="txt" class="padding-right" placeholder="请输入验证码" maxlength="6"
                                v-model="loginForm.code" clearable>
                            </el-input>
                            <el-button v-show="codeSta" class="get-code-btn" @click="getCode()">获取验证码</el-button>
                            <el-button v-show="!codeSta" class="get-code-btn">{{ count }}s</el-button>
                        </el-form-item>
                        <div class="find-pwd" v-if="loginWay === 1" @click="toFindPwd">忘记密码</div>
                        <div class="login-btn">
                            <el-button v-if="loginWay === 1" type="primary" @click="submitForm('loginForm')"
                                :disabled="!loginForm.userName || !loginForm.pwd">登录</el-button>
                            <el-button v-if="loginWay === 2" type="primary" @click="submitForm('loginForm')"
                                :disabled="!loginForm.tel || !loginForm.code">登录</el-button>
                        </div>
                    </el-form>
                </div>
                <!-- 提示栏 -->
                <div class="tellyou-bar">
                    <p>没有账号，<span @click="toRegister">立即注册</span></p>
                </div>
                <!-- 第三方登录 -->
                <div class="other-login" id="qrcodeWx">
                    <p ><i class="wechat-ico"></i></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import loginApi from '@/resources/loginModule/login'
    import config from '@/config'

    export default {
        data: function () {
            // 验证用户名
            let checkUserName = (rule, value, callback) => {
                let reg = /^[0-9A-Za-z]{6,16}$/
                if (!value) {
                    return callback(new Error("请输入账号"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入6-16个字母开头的数字、字母或下划线"));
                } else {
                    callback();
                }
            };
            // 验证密码
            let checkPwd = (rule, value, callback) => {
                // let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{5,15}$/g;
                let reg = /^[0-9A-Za-z]{6,16}$/
                if (!value) {
                    return callback(new Error("请输入密码"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入6-16个数字和字母的组合"));
                } else {
                    callback();
                }
            };
            // 验证手机号
            let checkTel = (rule, value, callback) => {
                let reg = /^1[34578]\d{9}$/;
                if (!value) {
                    return callback(new Error("请输入手机号"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            };
            return {
                loginWay: 1, //登录方式: 1 账号登录， 2 验证码登录
                codeSta: true, //获取验证码按钮状态
                count: "",
                timer: null,
                //表单数据
                loginForm: {
                    userName: "",
                    pwd: "",
                    tel: "",
                    code: ""
                },
                //校验
                rules: {
                    userName: [
                        { required: true, validator: checkUserName, trigger: "blur" }
                    ],
                    pwd: [{ required: true, validator: checkPwd, trigger: "blur" }],
                    tel: [{ required: true, validator: checkTel, trigger: "blur" }],
                    code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
                },
            };
        },
        computed: {},
        created() { },
        mounted() { },
        methods: {
            // 切换用户名和手机登录
            changeWay(data) {
                this.loginWay = data;
                this.resetForm("loginForm")
            },
            // 获取验证码倒计时
            getCode() {
                if (!this.loginForm.tel) {
                    this.$message.warning("请输入手机号");
                } else {
                    this.sendMobileCode();
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.codeSta = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.codeSta = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000);
                    }
                }
            },
            submitForm(formName) {
                var that = this;
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.loginWay === 1) {
                            let para = {
                                loginName: that.loginForm.userName,
                                pwd: that.loginForm.pwd,
                            }
                            loginApi.loginByAccount(para).then((res) => {
                                if (res.returnCode === 200) {
                                    that.$message.success("登录成功");
                                    // this.$router.push({ path: "/app/login" });
                                    console.log("this.loginForm:", that.loginForm)
                                }
                            })
                        } else {
                            let para = {
                                mobile: that.loginForm.tel,
                                captcha: that.loginForm.code,
                            }
                            loginApi.loginByMobileCaptcha(para).then((res) => {
                                if (res.returnCode === 200) {
                                    that.$message.success("登录成功");
                                    // this.$router.push({ path: "/app/login" });
                                    console.log("this.loginForm:", that.loginForm)
                                }
                            })
                        }

                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            //发送验证码
            sendMobileCode() {
                let that = this;
                let para = {
                    mobile: that.loginForm.tel,
                    operationFlag: 3    //1.注册 2.忘记密码 3.登录 4.绑定手机号
                };
                loginApi.sendMobileCode(para).then((res) => {
                    if (res.returnCode === 200) {
                        console.log("返回信息：", res)
                    }

                });
            },
            toRegister() {
                this.$router.push({ path: "/app/registe" });
            },
            toFindPwd() {
                this.$router.push({ path: "/app/findpassword" });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
        }
    };
</script>

<style scoped>
    @import "../../../assets/css/login/loginapp.css";
</style>